import Box from '@zenbusiness/zui/Box';
import Stack from '@zenbusiness/zui/Stack';
import { superstyled } from '@zenbusiness/zui/styles';

export const Root = superstyled({
  tag: Stack,
  name: 'FaqsSection',
  slot: 'Root',
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),

    [theme.breakpoints.up('lg')]: {
      flexDirection: 'row',
    },
  }),
});

export const TitleContainer = superstyled({
  tag: Box,
  name: 'FaqsSection',
  slot: 'TitleContainer',
  styles: {
    flex: 1,
  },
});

export const ItemsContainer = superstyled({
  tag: Stack,
  name: 'FaqsSection',
  slot: 'ItemsContainer',
  styles: {
    flex: 2,
  },
});
